/**
 * Native <dialog> open/close for course signup modals.
 */
export function initCourseSignupDialogs() {
	document.addEventListener(
		'click',
		(event) => {
			const openTrigger = event.target.closest('[data-open-dialog]');

			if (openTrigger) {
				event.preventDefault();

				const dialog = document.getElementById(openTrigger.getAttribute('data-open-dialog'));

				if (dialog && typeof dialog.showModal === 'function') {
					dialog.showModal();
				}

				return;
			}

			const closeTrigger = event.target.closest('[data-close-dialog]');

			if (closeTrigger) {
				event.preventDefault();

				const dialog = closeTrigger.closest('dialog');

				if (dialog && typeof dialog.close === 'function') {
					dialog.close();
				}
			}
		},
		true
	);

	document.querySelectorAll('dialog.course-signup-dialog').forEach((dialog) => {
		dialog.addEventListener('click', (event) => {
			if (event.target === dialog) {
				dialog.close();
			}
		});
	});
}
